/* NOREL — small progressive-enhancement script for header scroll state */
(function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  var lastY = window.scrollY;
  var ticking = false;

  function update() {
    if (window.scrollY > 12) {
      headerWrapper.classList.add('norel-scrolled');
    } else {
      headerWrapper.classList.remove('norel-scrolled');
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      lastY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  // Run once on load in case the page is already scrolled (e.g. back navigation)
  update();
})();
